/**
 * Scrolls smoothly to the container of the filters.
 *
 * @param filterRef
 */
const scrollToFilter = (filterRef) => {
    setTimeout(() =>
        filterRef?.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            }
        ), 1000);
}

/**
 * This controller looks into the URL's params and updates the apply state accordingly.
 *
 *
 * It should return the applyState object after being updated.
 *
 * @param applyState
 * @param setApplyState
 * @param filterRef
 * @param difficultyValues
 * @param mainIngredientValues
 * @param cookingTimeValues
 * @param courseValues
 * @param dietValues
 * @param styleValues
 * @param fuelTypeValues
 * @param featuredValues
 *
 *
 * @returns {*}
 * @constructor
 */
const URLParamsControllers = (
    activeFilters,
    setActiveFilters,
    setActiveFiltersCounter,
    applyState,
    setApplyState,
    filterRef,
    difficultyValues,
    mainIngredientValues,
    cookingTimeValues,
    courseValues,
    dietValues,
    styleValues,
    fuelTypeValues,
    featuredValues
) => {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has('wprm_difficulty')) {
        const difficulty = urlParams.get('wprm_difficulty');
        const value = difficultyValues?.find((item) => item.id === Number(difficulty) || item.slug === difficulty);

        if (value) {
            applyState.effortLevel.push(value.id);
            setApplyState(applyState)
        }
    }

    if (urlParams.has('wprm_main_ingredient')) {
        const mainIngredients = urlParams.get('wprm_main_ingredient');
        const value = mainIngredientValues?.find((item) => item.id === Number(mainIngredients) || item.slug === mainIngredients);

        if (value) {
            applyState.mainIngredients.push(value.id);
            setApplyState(applyState)
        }
    }

    if (urlParams.has('wprm_cooking_time')) {
        const cookingTime = urlParams.get('wprm_cooking_time');
        const value = cookingTimeValues?.find((item) => item.id === Number(cookingTime) || item.slug === cookingTime);

        if (value) {
            applyState.cookingTime.push(value.id);
            setApplyState(applyState)
        }
    }

    if (urlParams.has('wprm_course')) {
        const course = urlParams.get('wprm_course');
        let values = courseValues;
        // Check if it is an array or an object?
        if (typeof courseValues === 'object') {
            values = Object.values(courseValues);
        }
        const value = values?.find((item) => item.id === Number(course) || item.slug === course);

        if (value) {
            applyState.course.push(value.id);
            setApplyState(applyState)
        }
    }

    if (urlParams.has('wprm_diet')) {
        const diet = urlParams.get('wprm_diet');
        const value = dietValues?.find((item) => item.id === Number(diet) || item.slug === diet);

        if (value) {
            applyState.diet.push(value.id);
            setApplyState(applyState)
        }
    }

    if (urlParams.has('wprm_style')) {
        const style = urlParams.get('wprm_style');
        const value = styleValues?.find((item) => item.id === Number(style) || item.slug === style);

        if (value) {
            applyState.style.push(value.id);
            setApplyState(applyState)
        }
    }

    if (urlParams.has('wprm_fuel_type')) {

        const fuelType = urlParams.get('wprm_fuel_type');

        const value = fuelTypeValues?.find((item) => item.id === Number(fuelType) || item.slug === fuelType);

        if (value) {
            applyState.fuelType.push(value.id);
            setApplyState(applyState)
        }
    }

    if (urlParams.has('wprm_featured')) {
        const featured = urlParams.get('wprm_featured');

        const value = featuredValues?.find((item) => item.id === Number(featured) || item.slug === featured);

        if (value) {
            applyState.featured.push(value.id);
            setApplyState(applyState)
        }
    }

    if (urlParams.has('orderby')) {
        applyState.orderby = urlParams.get('orderby');
        setApplyState(applyState)
    }

    if (urlParams.has('scroll_to_filter')) {
        scrollToFilter(filterRef)
    }

    // check if current url has /recipes/top-recipes.
    if (window.location.pathname.includes('/recipes/top-recipes')) {
        applyState.orderby = '&orderby=rating&order=desc'
        setApplyState(applyState);
        scrollToFilter(filterRef);
    }

    // check if current url has /recipes/featured-recipes.
    if (window.location.pathname.includes('/recipes/featured-recipes')) {
        const featured = "featured";
        const value = featuredValues?.find((item) => item.id === Number(featured) || item.slug === featured);
        if (value) {
            applyState.featured.push(value.id);
            setApplyState(applyState);

            const newFilters = activeFilters.concat({id:value.id, name:value.name, taxonomy:value.taxonomy});
            setActiveFilters(newFilters);
            setActiveFiltersCounter(newFilters.length);

            scrollToFilter(filterRef);
        }
    }

    // check if current url has /recipes/pellet-recipes.
    if (window.location.pathname.includes('/recipes/pellet-recipes')) {
        const fuelType = "pellets";
        const value = fuelTypeValues?.find((item) => item.id === Number(fuelType) || item.slug === fuelType);
        if (value) {
            applyState.fuelType.push(value.id);
            setApplyState(applyState);

            const newFilters = activeFilters.concat({id:value.id, name:value.name, taxonomy:value.taxonomy});
            setActiveFilters(newFilters);
            setActiveFiltersCounter(newFilters.length);

            scrollToFilter(filterRef);
        }
    }

    // check if current url has /recipes/charcoal-recipes.
    if (window.location.pathname.includes('/recipes/charcoal-recipes')) {
        const fuelType = "charcoal";
        const value = fuelTypeValues?.find((item) => item.id === Number(fuelType) || item.slug === fuelType);
        if (value) {
            applyState.fuelType.push(value.id);
            setApplyState(applyState);

            const newFilters = activeFilters.concat({id:value.id, name:value.name, taxonomy:value.taxonomy});
            setActiveFilters(newFilters);
            setActiveFiltersCounter(newFilters.length);

            scrollToFilter(filterRef);
        }
    }

    return applyState;
}

export default URLParamsControllers;
